export default __webpack_public_path__ + "navigation-camera-geometry-framing-after-maneuver-disabled-960-181b33c0de221d751b72b77d4296f27d.png";